

























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import AdminFaqUpdateDialog from '@/modules/faq/components/admin/AdminFaqUpdateDialog.vue'
import { AdminFaqService } from '@/modules/faq/services/admin-faq.service'
import { FaqCollectionModel, FaqCollectionWithModel } from '@/modules/faq/models/faq-collection.model'

@Component({
  components: {
    BaseButton,
    ActionShowButton
  }
})
export default class AdminFaqActions extends Vue {

  constructor(
    private readonly service: AdminFaqService
  ) {
    super()
  }

  @Prop() faq!: FaqCollectionModel
  @Prop() withData!: FaqCollectionWithModel
  private faqItem: FaqCollectionModel = null

  editDialog() {
    this.faqItem = { ...this.faq }
    this.$q.dialog({
      component: AdminFaqUpdateDialog,
      faq: this.faqItem,
      withData: this.withData
    })
  }

  destroy() {
    this.service.destroy(this.faq.id)
  }
}

